export const xAPIKey = "W5zFgyrowo1noi3xygu4X4ogULf5SMJnaU82ZExr";
const stage = "Test";
const name = "da_24692_1c96f010";
export const lappURL = `https://lapps-in21.leadsquared.com/execute?name=${name}&stage=${stage}`;

export const toastStyle = {
    borderRadius: '10px',
    background: '#333',
    color: '#fff',
};
export const exceptionMessage = "Please wait for a moment..";
export const exp2 = `Please try again after some time.`;


export const importIframeURL = "https://insidesalesiframe.customui.leadsquared.com/?"
